function handleSweepstakeUpload(settings) {
	var $submit, $form, $modal;
	var formCompleted = true;

	settings = $.extend({
		uploadUrl: '',
		entrypage: '',
		afterUpload: null,
	}, settings);

	$(window).on("pageshow", function(event) {
        // Prevent cache when using the browser back button
        if (event.originalEvent.persisted) {
            window.location.reload();
        }
    });

	$(function() {
		$form   = $('form[name=participation]');
		$submit = $form.find('[type=submit]');
		$modal  = $('#photo-modal');

		$form.on('submit', function(e) {
		    $submit.addClass('loading');

			if (settings.photoSelected) {
				$form.find('.scanner').addClass('active');
			}
        });

		$('#take-photo-btn').on('click', function(e) {
			e.preventDefault();

			$('.photo-wrapper').removeClass('hidden');
			$modal.modal('show');
			$('.file-block').trigger('click');

			return false;
		});

		$form.photoUploader({
			uploadUrl: settings.uploadUrl,
			imagePreview: {
				onLoad: function(instance) {
					var size = instance.getBlobSize();
					$('.size').text('(' + Math.round(size / 1024) + 'KB)');
					$form.find('.input-error[data-field="photo"]').slideUp('fast');
					settings.photoSelected = true;
					checkSubmit();

					// setTimeout(function() {
					// 	smoothScrollToCenter($submit, 0, 500);
					// }, 500);
				}
			},
			onCompleted: function() {
				typeof(settings.afterUpload) === 'function' ? settings.afterUpload() : $form.submit();
			}
		});

		$form.find('.form-required input').on('change input', checkSubmit);

		checkSubmit();
	});

	function checkSubmit() {
		formCompleted = true;

		if (!settings.photoSelected) {
			formCompleted = false;
		}

		$submit.closest('.form-buttons').toggleClass('disabled', !formCompleted);
		$submit.toggleClass('incomplete', !formCompleted).prop('disabled', !formCompleted);
	}
}
